import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "step-2" }
const _hoisted_2 = { class: "hint-box flex mg-t-20" }
const _hoisted_3 = { class: "mg-r-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_WarningFilled = _resolveComponent("WarningFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_table, {
      data: _ctx.tableData,
      style: {"width":"100%"},
      "header-row-style": { color: '#202536' },
      "header-cell-style": { background: '#f8f8f8' },
      "row-style": { color: '#5E617D' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "index",
          label: "序号",
          width: "50"
        }),
        _createVNode(_component_el_table_column, {
          prop: "userName",
          label: "姓名"
        }),
        _createVNode(_component_el_table_column, {
          prop: "idCardNo",
          label: "身份证号"
        }),
        _createVNode(_component_el_table_column, {
          prop: "salaryAmount",
          label: "薪资标准"
        }),
        _createVNode(_component_el_table_column, {
          prop: "msg",
          label: "错误原因"
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_icon, { class: "fc-orange" }, {
          default: _withCtx(() => [
            _createVNode(_component_WarningFilled)
          ]),
          _: 1
        })
      ]),
      _cache[0] || (_cache[0] = _createElementVNode("div", null, [
        _createElementVNode("div", null, "以上人员信息有误，请在Excel里核对修改无误后重新导入。")
      ], -1))
    ])
  ]))
}